import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "placeholder"];
import React from 'react';
import { FormattedInput } from '../FormattedInput/FormattedInput';

/**
 * `InputPhone` proactively eliminates errors by restricting and formatting data to align with user expectations and business requirements.
 */
export var InputPhone = function InputPhone(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Phone number' : _ref$label,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '+1' : _ref$placeholder,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(FormattedInput, _extends({
    label: label,
    placeholder: placeholder
  }, otherProps, {
    format: "+1 (###) ### - ####" // Used to restrict what's available
    // to mobile users via keyboard. We
    // don't use the pattern attribute
    // as that will trigger validation in some
    // browsers like Firefox.
    ,
    type: "tel"
  }));
};